import { createBrowserAdminAdapter } from "data/admin/browserAdapter";

let activeAdminAdapter = createBrowserAdminAdapter();

export function configureAdminDataSource(adapter) {
  if (!adapter || typeof adapter.listCollection !== "function" || typeof adapter.writeCollection !== "function") {
    throw new Error("Admin data source adapter must implement listCollection and writeCollection");
  }

  activeAdminAdapter = adapter;
}

export function getAdminDataSource() {
  return activeAdminAdapter;
}

export function getAdminDataSourceInfo() {
  return {
    kind: activeAdminAdapter.kind,
    label: activeAdminAdapter.label,
  };
}
